import React from "react";
import "../CSS/menuGrid.css";
import StreamingText from "./StreamingText";
import { getItemImageUrl } from '../utils/subdomainUtils';

function MenuGrid({ options, onItemSelect, menuImages }) {
  // Sort options by percent_match (highest first)
  const sortedOptions = options?.slice().sort((a, b) => b.percent_match - a.percent_match) || [];

  // Use the centralized image URL function

  return (
    <div className="menu-recommendations-list">
      {sortedOptions.map((item, index) => (
        <div 
          key={item.id} 
          className={`recommendation-item ${index === 0 ? 'top-pick' : ''}`}
          onClick={() => onItemSelect(item)}
        >
          {/* Crown for top pick */}
          {index === 0 && (
            <div className="crown-badge">
              <span className="crown-icon">👑</span>
              <span className="crown-text">TOP PICK</span>
            </div>
          )}
          
          {/* Rank number */}
          <div className="rank-number">
            {index + 1}
          </div>
          
          {/* Item image */}
          <div className="item-image">
            <img src={getItemImageUrl(item.item_name, item.category, menuImages)} alt={item.item_name} />
          </div>
          
          {/* Item details */}
          <div className="item-details">
            <div className="item-header">
              <h3 className="item-name">{item.item_name}</h3>
              <div className="match-percentage">
                <span className="match-value">{item.percent_match}%</span>
                <span className="match-label">Match</span>
              </div>
            </div>
            
            <div className="recommendation-reason">
              <div className="reason-header">
                <span className="reason-icon">✨</span>
                <span className="reason-label">Why we picked this</span>
              </div>
              <div className="reason-text">
                <StreamingText text={item.reason} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MenuGrid;
